import request from '@/utils/request'

// 获取基本信息
export async function getSetInfoBaseApi() {
  return request('/mobile/basic/message', {
    method: 'GET',
  })
}

// 获取个人认证证件类型
export async function getIdCardTypeApi() {
  return request('/shop_api/basic/getIdCardType', {
    method: 'GET',
  })
}

// 更新基本信息
export async function putInformation(data: any) {
  return request('/mobile/basic/add_message', {
    method: 'PUT',
    data,
  })
}

// 个人实名认证
export async function postRealNameAuth(data: any) {
  return request('/umc/auth/user/person-real-name', {
    method: 'POST',
    data,
  })
}

// 企业实名认证
export async function postRealNameAuthEnterprise(data: any) {
  return request('/umc/auth/user/enterprise-real-name', {
    method: 'POST',
    data,
  })
}

// 个人实名认证
export async function getRealNameAuth() {
  return request('/mobile/basic/getCustomerRealNameAuth', {
    method: 'GET',
  })
}

// 企业实名认证
export async function getRealNameAuthEnterprise() {
  return request('/mobile/basic/getEnterpriseRealNameAuth', {
    method: 'GET',
  })
}

export async function getUmcVerify() {
  return request('/umc/auth/user/get-real-name-info', {
    method: 'POST',
  })
}

export const getOcrInfo = (data: any) => {
  return request('/umc/auth/ocr/identify', {
    method: 'POST',
    data,
  })
}

export const getUploadSign = (data: any) => {
  return request('/umc/common/upload/get-sign', {
    method: 'POST',
    data,
  })
}
